/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Specs_SummaryInputs */

const en_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processor / Specs`)
};

const es_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesador / Especificaciones`)
};

const fr_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processeur / Spécifications`)
};

const de_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozessor / Specs`)
};

const ja_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロセッサ / 仕様`)
};

const zh_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理器 / 规格`)
};

const ar_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعالج / المواصفات`)
};

const id_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosesor / Spek`)
};

const it_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processore / Specifiche`)
};

const ru_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Процессор / Характеристики`)
};

const pt_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processador / Especificações`)
};

const ko_field_specs_summary = /** @type {(inputs: Field_Specs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로세서 / 사양`)
};

/**
* | output |
* | --- |
* | "Processor / Specs" |
*
* @param {Field_Specs_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_specs_summary = /** @type {((inputs?: Field_Specs_SummaryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Specs_SummaryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_specs_summary(inputs)
	if (locale === "es") return es_field_specs_summary(inputs)
	if (locale === "fr") return fr_field_specs_summary(inputs)
	if (locale === "de") return de_field_specs_summary(inputs)
	if (locale === "ja") return ja_field_specs_summary(inputs)
	if (locale === "zh") return zh_field_specs_summary(inputs)
	if (locale === "ar") return ar_field_specs_summary(inputs)
	if (locale === "id") return id_field_specs_summary(inputs)
	if (locale === "it") return it_field_specs_summary(inputs)
	if (locale === "ru") return ru_field_specs_summary(inputs)
	if (locale === "pt") return pt_field_specs_summary(inputs)
	return ko_field_specs_summary(inputs)
});